/**
 * ResetPasswordConfirmation.jsx
 * Created by michaelbray on 2/14/18.
 * Updated by Destin Frasier on 1/11/19.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexCol, FlexRow } from '../../../sharedComponents/FlexGrid';
import Button from '../../../sharedComponents/Button';
import Heading from '../../../sharedComponents/Heading';

const propTypes = {
    email: PropTypes.string,
    sendResetPasswordEmail: PropTypes.func,
    disableResetLinkBtn: PropTypes.bool
};

export default class ResetPasswordConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.resendConfirmationEmail = this.resendConfirmationEmail.bind(this);
    }

    componentDidMount() {
        this.header.focus();
    }

    resendConfirmationEmail(e) {
        e.preventDefault();
        this.props.sendResetPasswordEmail();
    }

    render() {
        return (
            <FlexRow justifyContent="center">
                <FlexCol sm={8} className="rec-acct-modal-reset-confirmation-body">
                    <div ref={(header) => this.header = header} tabIndex="-1" className="rec-hide-focus">
                        <Heading
                            headingLevel={1}
                            appearance="display"
                            className="rec-acct-modal-title"
                            id="resetPasswordModalHeading">
                            Check Your Email
                        </Heading>
                    </div>
                    <p>
                        An email has been sent to <strong>{this.props.email}</strong>. Please click on the
                        link in that email to reset the password for your account. If you do not receive
                        the message, please check your spam folder.
                    </p>
                    <Button
                        shouldFitContainer
                        onClick={(e) => this.resendConfirmationEmail(e)}
                        size="lg"
                        title="Resend Email"
                        aria-label="Resend Email"
                        isDisabled={this.props.disableResetLinkBtn}>
                        Resend Email
                    </Button>
                </FlexCol>
            </FlexRow>
        );
    }
}

ResetPasswordConfirmation.propTypes = propTypes;
